import React from 'react';

import cn from 'clsx';
import * as css from './LeftNavWrapper.module.scss';

export default function LeftNavWrapper({ expanded, ...rest }) {
    return <div {...rest} className={cn(css.leftNavWrapper, expanded && css.expanded)} />;
}
